<template>
  <div
    class="
      $motion/transition:curve:case-in
      $motion/transition:duration:250ms
      $typography/size:large
      layout:bottom:0%
      layout/bottom:0%
      layout/fixed
      layout/left:0%
      layout/margin:bottom
      layout/margin:left
      layout/margin:right
      layout/margin:top
      layout/opacity
      layout/right:0%
      layout/top:0%
      layout/width
      layout/width:max
      layout/z-index:1
      motion/transition
    "
    :style="{
      '--layout--margin--top': 'calc(var(--header-height--current) + var(--page-spacing))',
      '--layout--margin--bottom': `calc(var(--page-spacing) + ${bannerHeight}px)`,
      '--layout--opacity': overlayOpacity,
      '--layout--margin--left': 'auto',
      '--layout--margin--right': 'auto',
      '--layout--width--max': 'calc((var(--page-width--maximum) - var(--page-spacing) * 2) * 2/3)',
      '--layout--width': 'calc(100% - var(--page-spacing) * 2)',
    }"
    >
    <div
      class="
        $color/background:white
        color/background
        layout/border:3pt
        layout/height:100%
        layout/relative
        layout/width:100%
      "
      >
      <spinner
        class="
          $motion/transition:curve:case-in
          $motion/transition:duration:250ms
          layout/absolute:center
          layout/opacity
          link/disable
          motion/transition
        "
        :style="{
          '--layout--opacity': spinnerOpacity,
        }"
      />
      <iframe
        class="
          $motion/transition:curve:case-in
          $motion/transition:duration:250ms
          layout/height:100%
          layout/opacity
          layout/width:100%
          motion/transition
        "
        :style="{
          '--layout--opacity': iframeOpacity,
        }"
        :src="url"
        @load="formLoaded = true"
      />
      <div
        class="
          $layout/page:fixed
          layout/absolute
          layout/padding:right:page
          layout/padding:top:page
          layout/right:0%
          layout/top:0%
        "
        >
        <button
          class="
            link/focus
          "
          @click.prevent="dismiss"
          >
          <icon
            icon-name="icon__x--24--stroke.svg"
            class-name="
              $typography/size:medium
              typography/icon
            "
          />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import Icon from 'Components/icons/icon';
  import Spinner from 'Components/shared/spinner';
  import KeyCodes from 'Utils/key-codes';

  export default {
    components: {
      Icon,
      Spinner,
    },
    props: {
      url: {type: String, required: true},
    },
    data() {
      return {
        show: false,
        formLoaded: false,
        bannerTray: document.querySelector('[data-banner-tray]'),
        bannerHeight: document.querySelector('[data-banner-tray]') ? document.querySelector('[data-banner-tray]').offsetHeight : 0,
      };
    },
    computed: {
      overlayOpacity: function() {
        return this.show ? '100' : '0';
      },
      spinnerOpacity: function() {
        return this.formLoaded ? '0' : '100';
      },
      iframeOpacity: function() {
        return this.formLoaded ? '100' : '0';
      },
    },
    mounted() {
      window.addEventListener('keydown', this.keydown);
      if (this.bannerTray) {
        this.bannerTray.addEventListener('transitionend', this.updateBannerHeight);
        this.updateBannerHeight();
      }

      setTimeout(() => {
        this.show = true;
      }, 50);
    },
    destroyed() {
      window.removeEventListener('keydown', this.keydown);
      if (this.bannerTray) {
        this.bannerTray.removeEventListener('transitionend', this.updateBannerHeight);
      }
    },
    methods: {
      updateBannerHeight: function() {
        this.bannerHeight = this.bannerTray.offsetHeight;
      },
      dismiss: function() {
        this.show = false;
        this.$emit('dismiss');

        setTimeout(() => {
          this.$destroy();
          this.$el.parentNode.removeChild(this.$el);
        }, 500);
      },
      keydown: function(e) {
        if (e.keyCode === KeyCodes.ESCAPE) {
          this.dismiss();
        }
      },
    }
  };
</script>
